import * as Sentry from "@sentry/react";

const mutedReduxPayloadTypes = [
    "MEMBERSHIP_UPDATE",
    "liveRadio/update",
    "newsletters/load_data",
    "preferences/set_user",
    "schedule/receive_main",
    "schedule/receive_rightRail",
];

const formatReduxPayloadForSentry = (action) => {
    if (!action || !action?.payload || !action?.type) return null;

    const isReduxPayloadMuted = mutedReduxPayloadTypes.includes(action.type);

    return isReduxPayloadMuted
        ? { payload: "REDUX TYPE MUTED" }
        : { payload: action.payload };
};

export const sentryReduxMiddleware = () => (next) => (action) => {
    Sentry.addBreadcrumb({
        category: "redux.action",
        type: "info",
        message: `Type: "${action.type}"`,
        data: formatReduxPayloadForSentry(action),
    });

    return next(action);
};
